// extracted by mini-css-extract-plugin
module.exports = {"search":"search-module--search--2K1sf","desktop":"search-module--desktop--dH8HK"};